<template>
<div>
    <MenuAccount/>
    <div class="d-flex align-center">
        <div class="img_title_sale_statistic">
            <img src="@/assets/icon-sale-report-food.png">
        </div>
        <h2 class="header_sale_statistic">ดูสถิติยอดขายอาหาร</h2>
    </div>
    <v-card>
        <div class="pa-3">

            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between card_menu_header_sale_statistic">
                        <div class="mr-1">
                            <v-btn :color="title === 'food' ? '#038cc1' : ''" @click="page('food')" :class="title === 'food' ? 'white--text' : ''" height="50px" width="100%">เมนูอาหาร</v-btn>
                        </div>
                        <div class="ml-1">
                            <v-btn :color="title === 'topping' ? '#038cc1' : ''" @click="page('topping')" :class="title === 'topping' ? 'white--text' : ''" height="50px" width="100%">ท็อปปิ้ง</v-btn>
                        </div>
                        <div class="ml-1">
                            <v-btn :color="title === 'food_cancel' ? '#038cc1' : ''" @click="page('food_cancel')" :class="title === 'food_cancel' ? 'white--text' : ''" height="50px" width="100%">รายการอาหารที่ถูกยกเลิก (ไม่คืนวัตถุดิบ)</v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <SaleStatisticType :title="title" />
                </v-col>
            </v-row>

        </div>
    </v-card>
</div>
</template>

<script>
import SaleStatisticType from '@/components/menuadmin/SaleStatisticType.vue'
import MenuAccount from "@/components/menuadmin/account/accountheader/MenuAccount";
export default {
    name: 'saleStatistic',
    components: {
      MenuAccount,
        SaleStatisticType
    },
    data() {
        return {
            title: 'food',
        }
    },
    methods: {
        async page(type) {
            this.title = type
        },

    }
}
</script>
